import {useCartContext} from 'modules/Cart/contexts/cartContext';
import {useCallback, useMemo} from 'react';

export function useCartProducts() {
    const {
        products: productsEntities,
        productsIds,
        setProductCount,
        setDeleted,
        setChecked,
        setAllChecked,
    } = useCartContext();

    const products = useMemo(() => {
        return productsIds.map((id) => productsEntities[id]);
    }, [productsEntities, productsIds]);

    const makeHandleChangeCount = useCallback(
        (productId: number) => (count: number) => {
            setProductCount(productId, count);
        },
        [setProductCount],
    );

    const makeHandleRemove = useCallback(
        (productId: number) => () => {
            setDeleted(productId, true);
        },
        [setDeleted],
    );

    const makeHandleRestore = useCallback(
        (productId: number) => () => {
            setDeleted(productId, false);
        },
        [setDeleted],
    );

    const makeHandleCheck = useCallback(
        (productId: number) => (checked: boolean) => {
            setChecked(productId, checked);
        },
        [setChecked],
    );

    const handleAllCheck = useCallback(
        (checked: boolean) => {
            setAllChecked(checked);
        },
        [setAllChecked],
    );

    const isAllChecked = useMemo(() => {
        return products.every((product) => product.checked);
    }, [products]);

    return {
        products,
        isAllChecked,
        makeHandleChangeCount,
        makeHandleRemove,
        makeHandleRestore,
        makeHandleCheck,
        handleAllCheck,
    };
}
